import { useTranslation } from "react-i18next";
import { playStoreUrl, type PlayPlacement } from "../../lib/playStore";

export default function AndroidInstallLink({ placement, className = "" }: { placement: PlayPlacement; className?: string }) {
  const { t } = useTranslation();
  return <a href={playStoreUrl(placement)} className={`inline-flex min-h-11 items-center justify-center rounded-lg border border-brass-400/60 bg-brass-500/10 px-5 py-3 text-brass-200 hover:bg-brass-500/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brass-300 ${className}`}>
    {t("ui.web.android.get", { lng: "en" })}
  </a>;
}
